import { Translate } from "ra-core";
import type { ReactNode } from "react";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FilterCategory = ({
  icon,
  label,
  children,
  // When provided, renders as an AccordionItem with this value.
  // Wrap multiple FilterCategory components in <Accordion type="multiple"> in the parent.
  accordionValue,
}: {
  icon: ReactNode;
  label: string;
  children?: ReactNode;
  accordionValue?: string;
}) => {
  if (accordionValue) {
    return (
      <AccordionItem value={accordionValue} className="border-none">
        <AccordionTrigger className="py-2 hover:no-underline">
          <span className="flex flex-row items-center gap-2 font-bold text-sm">
            {icon}
            <Translate i18nKey={label} />
          </span>
        </AccordionTrigger>
        <AccordionContent className="pb-2">
          <div className="flex md:flex-col flex-wrap items-start pl-4">
            {children}
          </div>
        </AccordionContent>
      </AccordionItem>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <h3 className="flex flex-row items-center gap-2 font-bold text-sm">
        {icon}
        <Translate i18nKey={label} />
      </h3>
      <div className="flex md:flex-col flex-wrap items-start pl-4">
        {children}
      </div>
    </div>
  );
};
